var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_c('IdNameForm',{attrs:{"userData":_vm.userData}}),(_vm.userData.signupPath !== 'kakao' && !_vm.isAuthorized)?_c('PasswordForm',{attrs:{"userData":_vm.userData}}):_vm._e(),_c('EmailForm',{ref:"refEmailForm",attrs:{"userData":_vm.userData}}),_c('AgeForm',{attrs:{"userData":_vm.userData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }